import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { SVGVehicleModel } from './../../vehicle/models/vehicle.model';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';
import { VehicleModel } from '../../vehicle/models/vehicle.model';
import { SharedVehicleGroupService } from '../models/sharedvehiclegroup.service';
import { SharedVehicleGroupModel } from '../models/sharedvehiclegroup.model';


@Component({
  selector: 'wego-add-groupvehicle-popup',
  template: require('../views/add-groupvehicle-popup.component.html'),
})

export class AddGroupVehiclePopupComponent implements OnInit, OnChanges {
  DataListModel: DataListModel;
  vehicleList: VehicleModel[];
  SVGVehicleModel: SVGVehicleModel;
  message: string;
  apiErrorMsg: string;
  urlPersonUpdate: string;
  isLoading: boolean;
  isParentCheck: boolean;
  LblAssignVehicle: string;
  LblIcon: string;

  public sharedVehicleGroupHashId: string;
  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('vehicleModal') public vehicleModal: any;


  get isAnyChecked(): boolean {
    if (this.vehicleList) {
      let isCheck = this.vehicleList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.vehicleList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }
      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }
  constructor(private sharedVehicleGroupService: SharedVehicleGroupService
    , private authService: AuthService
    , private router: Router, private translate: TranslateService) { }

  ngOnInit() {
    this.LblAssignVehicle = this.translate.instant('LblAssign') + this.translate.instant('LblVehicle');
    this.LblIcon = 'fa fa-plus-square';
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["licenceTag", "ownerName", "brand", "type", "vehicleClass"
      , "color"];
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.GetVehicleForGroup();
    this.vehicleModal.show();
  }

  public hide(): void {
    this.vehicleModal.hide();
  }

  private GetVehicleForGroup() {
    this.isLoading = true;
    this.sharedVehicleGroupService.GetVehicleListForGroup(this.sharedVehicleGroupHashId, this.DataListModel)
      .subscribe(
      res => {
        this.vehicleList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public OnParentCheck(isChecked: boolean) {
    this.vehicleList.forEach(x => x.isChecked = isChecked);
  }
  private select(vehicleMasterHashId: string): void {
    this.isLoading = true;
    let model = new SVGVehicleModel();
    model.vehicleHashId = vehicleMasterHashId;
    model.sharedvehiclegroupHashId = this.sharedVehicleGroupHashId;
    this.sharedVehicleGroupService.AssignGroupVehicle(model)
      .subscribe(
      res => {
        this.message = this.translate.instant('LblRecordSavedSuccess')
        this.OnSuccessSelect();
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => {
        this.vehicleModal.hide();
        this.isLoading = false;
      });
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetVehicleForGroup();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetVehicleForGroup();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetVehicleForGroup();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetVehicleForGroup();
  }
  private OnSuccessSelect() {
    this.onSuccessSelect.emit({ SuccessMessage: this.message })
  }

  private OnAdd(event: any) {
    let vehicleHashIdList: any[];
    vehicleHashIdList = this.vehicleList.filter(x => x.isChecked).map(x => x.vehicleMasterHashId);
    this.isLoading = true;
    let model = new SVGVehicleModel();
    model.listOfVehicleHashId = vehicleHashIdList;
    model.sharedvehiclegroupHashId = this.sharedVehicleGroupHashId;
    this.sharedVehicleGroupService.AssignGroupVehicle(model)
      .subscribe(
      res => {
        this.message = this.translate.instant('LblRecordSavedSuccess')
        this.OnSuccessSelect();
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => {
        this.vehicleModal.hide();
        this.isLoading = false;
      });

  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sharedvehiclegroup/components/add-groupvehicle-popup.component.ts